import { type FC } from 'react';
import cn from 'classnames';

import { lightImages } from '@/assets/img/common';
import { wheelImages } from '@/assets/img/contract';
import { usdImages } from '@/assets/img/wallet';
import { Button } from '@/components/ui/Button/Button';
import { Picture } from '@/components/ui/Picture/Picture';

import { useDailyGoodsLink } from './daily-goods-link.hook';
import { DailyGoodsTimerCycle } from './DailyGoodsTimerCycle';

interface DailyGoodsLinkProps {
  className?: string;
}

const DailyGoodsLink: FC<DailyGoodsLinkProps> = ({ className }) => {
  const { isVisible, onClick, expiredAt } = useDailyGoodsLink();

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      onClick={onClick}
      variant="transparent"
      className={cn(
        'flex flex-col items-center pointer-events-auto',
        className,
      )}
    >
      <div className="size-12 relative flex items-center justify-center">
        <Picture
          className="absolute aspect-[72/58] w-[4rem] opacity-90"
          img={lightImages.purpleSm.png}
          webp={lightImages.purpleSm.webp}
          alt="purple light"
        />
        <Picture
          className="absolute -top-[2px] -right-[2px] size-6 rotate-[15deg]"
          img={usdImages.icon.png}
          webp={usdImages.icon.webp}
          alt="usd"
        />
        <Picture
          className="size-full relative z-1 scale-x-[-1]"
          img={wheelImages.purple.png}
          webp={wheelImages.purple.webp}
          alt="wheel"
        />
      </div>
      <DailyGoodsTimerCycle expiredAt={expiredAt} />
    </Button>
  );
};

export { DailyGoodsLink };
